import Paragraph from "~/componentsDS/Typography/Paragraph";
import Image from "next/image";
import { cn } from "~/lib/utils";
import type { HormoneSupportOestraMobileContent } from "../../data/hormone-support-content";

const OESTRA_MOBILE_GRADIENT =
    "bg-[linear-gradient(180deg,_#19223D_2.38%,_#2A3966_39.12%,_#A9B9E5_161.17%)]";

const HormoneSupportOestraCardMobile = ({ content }: { content: HormoneSupportOestraMobileContent }) => {
    return (
        <div
            className={cn(
                "relative max-w-[352px] w-full h-[520px] md:h-[526px] px-4 md:px-6 pt-8 pb-6 text-center rounded-2xl overflow-hidden",
                "shadow-[1px_1px_9.2px_0_rgba(0,0,0,0.25)]",
                content.showGradientOverlay && OESTRA_MOBILE_GRADIENT
            )}
        >
            <div className="absolute inset-0 pointer-events-none">
                <div className="relative w-full h-full">
                    <Image
                        src={content.image}
                        alt={content.imageAlt}
                        fill
                        sizes="(max-width: 767px) 100vw, 50vw"
                        className="object-cover object-center"
                    />
                </div>
            </div>

            <div className="relative flex flex-col h-full pb-4 text-pureWhite">
                {content.badge}

                <div className="mt-auto">
                    <Paragraph as="h3" size="lg" weight="500" className="mb-[10px]">
                        {content.description}
                    </Paragraph>
                    <ul>
                        {content.bullets.map((item) => (
                            <li key={item}>
                                <Paragraph>{item}</Paragraph>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
};

export default HormoneSupportOestraCardMobile;
